<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :options="[
        { type: 'date', label: '점검일', value: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태', value: '재해형태' },
        { type: 'alert', label: '알림 대상자 선택' },
      ]"
    />

    <!--    해당사업장-->
    <related-field-list
      class="mt-28px"
      title="해당사업장"
      :list="form.relatedFieldList"
      @updateList="updateRelatedFieldList"
      :is-print="isPrint"
      :is-readonly="board.readonly"/>

    <!-- 안전점검 사항 -->
    <table-custom
      thema="label"
      :controls="false"
      :multiple="false"
      :board="board"
      :is-print="isPrint"
      title="안전점검 사항"
      :tableData="[
        { id: 'labelText', title: '구분', type: 'label', width: 200 },
        { id: 'input1', title: '위험요인', type: 'textarea', placeholder: '' },
        { id: 'input2', title: '개선대책', type: 'textarea', placeholder: '' },
        { id: 'input3', title: '비고', type: 'textarea', placeholder: '' },
      ]"
      :mobile="['labelText']"
      v-model="form.safetyInspection"
      class="mt-4"
    />

    <!-- 표 -->
    <div v-for="(inspection, inspection_i) in form.inspectList" :key="inspection_i">
      <TableInspectMerge
        :key="`inspection_${inspection.title}`"
        :is-print="isPrint"
        :is-readonly="board.readonly"
        :title="inspection.title"
        :tableHeaderTitle="[{ text: '점검사항', width: 300 }, { text: '점검내용' }]"
        :tableHeaderCheck="[{ text: '적정' }, { text: '미흡' }, { text: '해당없음' }]"
        :tableHeaderNote="[{ text: '비고' }]"
        :contentBefore="[inspection_i === 0 ? 'numbering' : '', '•']"
        v-model="inspection.list"
        :class="4 < inspection_i ? 'mt-4' : 'mt-28px'"
      >
        <template #trFooter>
          <div v-if="inspection_i === 0">
            <div style="border-bottom: solid 1px #cdcdcd; padding: 14px">
              <div style="font-weight: 500; font-size: 14px; line-height: 20px; color: #3c3c3c">특이사항</div>
            </div>
            <div class="p-2" style="background-color: #ffffff">
              <ml-textarea class="flex-1 w-full" rows="3" v-model="form.inputE_1" :readonly="board.readonly" />
            </div>
          </div>
        </template>
      </TableInspectMerge>
      <div v-if="inspection_i === 0" class="mt-4">
        ※ 수급인 안전보건교육, 작업계획서, 위험성평가 등 실시여부 안전보건자료 확인 할 것<br />
        ※ 수급인 사업주 안전보건예산 집행 내역 증빙자료 제출 할 것 (사진대지, 영수증 등)
      </div>
    </div>

    <!-- 안전점검 실시자 명단 -->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="안전점검 실시자 명단"
      :tableData="[
        { id: 'type', title: '소속명', type: 'text' },
        { id: 'name', title: '성명', type: 'text', placeholder: '' },
        { id: 'sign', title: '서명', type: 'sign', placeholder: '' },
        { id: 'other', title: '비고', type: 'text', placeholder: '' },
      ]"
      :mobile="['labelText']"
      v-model="form.executives"
      class="mt-4"
    />

    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 확인자</h5>
      <div class="writeGridContainer">
        <div>
          <div>담당</div>
          <ml-input v-model="form.sign1.name" :readonly="board.readonly" />
        </div>
        <div>
          <div>서명</div>
          <sign-field v-model="form.sign1.sign" :readonly="board.readonly" />
        </div>
      </div>
      <div class="writeGridContainer">
        <div>
          <div>팀장</div>
          <ml-input v-model="form.sign2.name" :readonly="board.readonly" />
        </div>
        <div>
          <div>서명</div>
          <sign-field v-model="form.sign2.sign" :readonly="board.readonly" />
        </div>
      </div>
      <div class="writeGridContainer">
        <div>
          <div>과장</div>
          <ml-input v-model="form.sign3.name" :readonly="board.readonly" />
        </div>
        <div>
          <div>서명</div>
          <sign-field v-model="form.sign3.sign" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!-- 사진대지 -->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" section-title="사진대지" />

    <file-upload-module class="mt-28px" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspectMerge from "@/components/TableInspectMerge";
import TableCustom from "@/components/TableCustom.vue";
import { required } from "vuelidate/lib/validators";
import InspectData from "./InspectData";
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";
import SignField from "@/components/SignField.vue";
import RelatedFieldList from "@/components/RelatedFieldList.vue";

export default {
  components: {
    RelatedFieldList,
    FieldSelectModule,
    PhotoUploadGridModule,
    FileUploadModule,
    TableInspectMerge,
    TableCustom,
    PrintCheckbox,
    SignField,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      stdInfo: {
        field_name: { required },
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},

        safetyInspection: [
          { id: 1, labelText: "일반관리", input1: "", input2: "", input3: "" },
          { id: 2, labelText: "작업장 안전보건", input1: "", input2: "", input3: "" },
        ],

        inspectList: JSON.parse(JSON.stringify(InspectData)),
        relatedFieldList: [],

        executives: [],

        sign1: { name: "", sign: "" },
        sign2: { name: "", sign: "" },
        sign3: { name: "", sign: "" },

        photoList: [],
        fileList: [],
      },
    };
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        if (value) {
          const keys = Object.keys(value);
          for (const key of keys) {
            if (value[key]) {
              this.form[key] = value[key];
            }
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.field_name.required) {
          alert("사업장명을 반드시 입력해야 합니다");
        }
        return false;
      } else {
        // 유효성 검사가 성공한 경우
        return true;
      }
    },
    inputCheckbox56(value) {
      this.$set(this.form.inspectList[5], "check", value);
      this.$set(this.form.inspectList[6], "check", value);
    },
    updateRelatedFieldList (list) {
      this.form.relatedFieldList = list;
    },
  },
};
</script>
